import React from "react";
import { Formik, useField } from "formik";

const COLORS = [
  "#AD1457",
  "#C62828",
  "#D84315",
  "#EF6C00",
  "#F9A825",
  "#2E7D32",
  "#558B2F",
  "#0D47A1",
  "#0277BD",
  "#00ACC1",
  "#4527A0",
  "#6A1B9A",
];

const Colors = () => {
  const [field, meta, helpers] = useField("color");
  return (
    <div>
      {COLORS.map((color) => {
        const isSelected = color === field.value;
        return (
          <div
            className="elegirColor"
            onClick={() => {
              // console.log(field.value);
              helpers.setValue(color);
            }}
            key={color}
            style={{
              backgroundColor: color,
              cursor: "pointer",
              width: "38px",
              height: "38px",
              border: `3px solid ${isSelected ? "#000000" : "transparent"}`,
            }}
          />
        );
      })}
    </div>
  );
};
export default Colors;
